import { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './styles.module.sass';

type RequestACallWrapperProps = {
  children: ReactNode;
  className?: string;
};

// @ts-expect-error - Automatic, Please fix when editing this file
const RequestACallWrapper = ({ children, className = null }: RequestACallWrapperProps) => (
  <section className={classNames(styles.form, styles.active, className)}>{children}</section>
);

export default RequestACallWrapper;
